<template>
  <div class="col-lg-12">
    <vue-headful :title="`Settings • ${$store.state.settings.settings.site_name}`" />
    <h1>Admin Settings</h1>
    <card>
      <tabs
        type="info"
        :value="activeTab">
        <tab-pane
          id="general"
          link="/settings/general"
          label="General">
          <settings-general
            :settings="settings"
            @updateSettings="$emit('updateSettings', $event)" />
        </tab-pane>
        <tab-pane
          id="emails"
          link="/settings/emails"
          label="Emails">
          <settings-emails
            :settings="settings"
            @updateSettings="$emit('updateSettings', $event)" />
        </tab-pane>
      </tabs>
    </card>
  </div>
</template>
<script>
import { TabPane, Tabs } from 'src/components/UI';
import SettingsGeneral from './SettingsGeneral.vue';
import SettingsEmails from './SettingsEmails.vue';

export default {
  name: 'Settings',
  components: {
    TabPane,
    Tabs,
    SettingsEmails,
    SettingsGeneral,
  },
  props: {
    activeTab: {
      type: String,
      required: true,
    },
    settings: {
      type: Object,
      required: true,
    },
  },
};
</script>
